
<div class="global-dialog">



    <p mat-dialog-title class='popup-title text-title-size'>
        {{languageService.Strings.cookies.popupTitle}}
    </p>

    <mat-dialog-content>
        <p class='popup-text noraml-text-size'> 
            {{languageService.Strings.cookies.popupText_1}}<!--
            --><span (click)="openMarkdownFile(markdownFiles.cookiePolicy)" class="bold-clickable">{{languageService.Strings.cookies.popupText_2}}</span><!--
            -->{{languageService.Strings.cookies.popupText_3}}
        </p>
    </mat-dialog-content>


    <mat-dialog-actions id="actions-conatiner">

        <div class="base_buttons_container">
            <!-- Reject button -->        
            <button mat-raised-button 
                    cdkFocusInitial
                    color="primary"
                    class="base_buttons"
                    (click)="rejectButtonClicked()" > 
                {{languageService.Strings.buttons.button_reject}}
            </button>  
            <!-- Accept button -->        
            <button mat-raised-button 
                    cdkFocusInitial
                    color="primary"
                    class="base_buttons"
                    (click)="acceptButtonClicked()" > 
                {{languageService.Strings.buttons.button_accept}}
            </button>   
        </div>
        
    </mat-dialog-actions>


</div>